import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-up",
  "use": "icon-up-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-up\"><path d=\"M884.0192 768H808.96a16.0768 16.0768 0 0 1-12.9024-6.6048L512 369.8176 227.8912 761.344A16.0768 16.0768 0 0 1 215.04 768H139.9808a8.0384 8.0384 0 0 1-6.5024-12.6976l352.6144-486.0928a31.8976 31.8976 0 0 1 51.712 0l352.6144 486.0928a7.9872 7.9872 0 0 1-6.4 12.6976z\" fill=\"\" p-id=\"3530\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol